import { Plus } from 'lucide-react';
import { useCallback, useEffect, useState } from 'react';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import useWorkspaceStore from '@/stores/WorkspaceStore';

import type { AskSlackResponse } from '../../Integrations/integrationRedirection/ask-slack';
import slackAskBotService from './service';
import SlackConnectionItem from './SlackConnectionItem';
import { getSlackAskBotConnectionUrl } from './SlackConnectionUtil';
import type { SlackAskBotInfoT } from './types';

const SlackConnectionList = () => {
  const { currWorkspace } = useWorkspaceStore((state) => ({
    currWorkspace: state.currWorkspace,
  }));
  const [slackAskBotInfos, setSlackAskBotInfos] = useState<SlackAskBotInfoT[]>(
    [],
  );

  const deleteWorkspace = useCallback(async (id: string) => {
    await slackAskBotService.deleteSlackAskBotInfo(id);
    setSlackAskBotInfos((prev) => prev.filter((info) => info.id !== id));
  }, []);

  const handleConnectClick = useCallback(() => {
    if (!currWorkspace) return;
    const url = getSlackAskBotConnectionUrl(currWorkspace.alias);
    window.open(url);
  }, [currWorkspace]);

  const [redirect, setRedirect, removeKey] =
    useCrossWindowState<AskSlackResponse | null>('ask-slack-redirect', null);

  useEffect(() => {
    if (!currWorkspace) return;
    if (redirect) {
      setRedirect(null);
      slackAskBotService.fetchSlackAskBotInfoList().then((infos) => {
        setSlackAskBotInfos(infos);
      });
      removeKey();
    }
  }, [currWorkspace, redirect, removeKey, setRedirect]);

  useEffect(() => {
    if (!currWorkspace) return;
    slackAskBotService.fetchSlackAskBotInfoList().then((infos) => {
      setSlackAskBotInfos(infos);
    });
  }, [currWorkspace, setSlackAskBotInfos]);
  return (
    <Flex d="column">
      <Flex d="column" g="8px">
        {slackAskBotInfos.length > 0 ? (
          slackAskBotInfos.map((info) => (
            <SlackConnectionItem
              key={info.id}
              info={info}
              setInfos={setSlackAskBotInfos}
              deleteWorkspace={deleteWorkspace}
            />
          ))
        ) : (
          <SlackConnectionItem key="new-workspace" />
        )}
      </Flex>
      {
        <Flex j="flex-start" g={4} a="center" style={{ padding: '8px 0' }}>
          <Button
            leftIcon={<Plus />}
            variant="ghost_secondary"
            onClick={handleConnectClick}
          >
            Add more Slack integration
          </Button>
        </Flex>
      }
    </Flex>
  );
};
export default SlackConnectionList;
